const statsItems = {
  STATS_ITEMS_FETCH: 'STATS_ITEMS_FETCH',
  STATS_ITEMS_SUCCESS: 'STATS_ITEMS_SUCCESS',
  STATS_ITEMS_ERROR: 'STATS_ITEMS_ERROR',
};


const output = { ...statsItems };
export default output;
